import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { useAppContext } from "@/providers/app-context";
import { Loader2 } from "lucide-react";
import React from "react";
import { Checkbox } from "./checkbox";

export function Confirmation() {
  const { useConfirmation } = useAppContext();
  const confirmation = useConfirmation();
  const [isLoading, setIsLoading] = React.useState(false);
  const [checkboChecked, setCheckboChecked] = React.useState(false);

  return (
    <AlertDialog open={confirmation.isOpen}>
      <AlertDialogContent className="z-[75]" overlayClassname="z-[74]">
        <AlertDialogHeader>
          <AlertDialogTitle>{confirmation.title}</AlertDialogTitle>
          <AlertDialogDescription>
            {confirmation.description}

            {confirmation.checkbox ? (
              <div className="mt-4 flex items-center space-x-2">
                <Checkbox
                  id="confirmCheckbox"
                  checked={checkboChecked}
                  onCheckedChange={(val: boolean) => setCheckboChecked(val)}
                />
                <label htmlFor="confirmCheckbox" className="cursor-pointer">
                  {confirmation.checkboxLabel}
                </label>
              </div>
            ) : null}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          {!confirmation.hideCancel && (
            <AlertDialogCancel onClick={confirmation.close}>
              {confirmation.cancelText || "Cancel"}
            </AlertDialogCancel>
          )}
          <AlertDialogAction
            className="relative"
            onClick={async () => {
              setIsLoading(true);
              try {
                await confirmation.callback?.(checkboChecked);
                confirmation.close();
              } finally {
                setIsLoading(false);
              }
            }}
            disabled={isLoading}
          >
            <span style={{ visibility: isLoading ? "hidden" : "visible" }}>
              {confirmation.confirmText || "Continue"}
            </span>
            {isLoading && (
              <div
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                }}
                className="bg-rd-500"
              >
                <Loader2 className="animate-spin" />
              </div>
            )}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
